module.exports = JSON.parse('{"Tracked series":"{{trackedSeries}} Tracked series"}')